import { Area } from "Models/Areas/Area";

export interface IAreaState {
    companyAreas: Area[];
}

export class AreaState implements IAreaState {
    public companyAreas: Area[];
}


// WEBPACK FOOTER //
// ./src/Store/Areas/AreaState.ts